














import { Component, Prop, Vue, Model } from 'vue-property-decorator';

@Component<CheckboxLegend>({
  computed: {
    name() {
      return this.label.replace(/[^A-Z0-9]+/gi, '_').toLowerCase();
    }
  }
})
export default class CheckboxLegend extends Vue {
  @Model('input', { type: Boolean }) modelValue!: boolean;

  @Prop(String) label!: string;
  @Prop(String) color!: string;

  get boxStyle() {
    return {
      backgroundColor: this.color
    };
  }
}
